import { LitElement, html } from 'lit';
import styles from './fit-simple-dropdown.css';

class FitSimpleDropdown extends LitElement {
  static get is() { return 'fit-simple-dropdown'; }

  static get styles() { return styles; }

  render() {
    return html`
    <input id="input" class="acts-as-select" type="text" readonly placeholder="${this.label}">
    <select id="select" .value="${this.selected}" @change="${this._handleSelection}" @mouseover="${this._hover}" @mouseleave="${this._hover}"></select>`;
  }

  static get properties() {
    return {

      selected: {
        type: String,
      },

      options: {
        type: Array,
      },

      keepLabel: {
        type: Boolean,
        attribute: 'keep-label',
      },

    };
  }

  firstUpdated(changedProperties) {
    this.$ = {};
    this.$.input = this.shadowRoot.querySelector('#input');
    this.$.select = this.shadowRoot.querySelector('#select');
  }

  updated(changedProperties) {
    if (changedProperties.has('label') || changedProperties.has('selected')) {
      this._labelChanged(this.label, this.selected);
    }
    if (changedProperties.has('options')) {
      this._renderOptions(this.options);
    }
    if (changedProperties.has('selected') || changedProperties.has('keepLabel')) {
      this._selectedChanged(this.selected);
    }
  }

  static get observers() {
    return [
      '_renderOptions(options)',
      '_selectedChanged(selected)',
      '_labelChanged(label, selected)'];
  }

  _labelChanged(label, selected) {
    if (!label) return;

    const firstChild = this.$.select.querySelector('*:first-child');

    if (firstChild && firstChild.dataset.labelOption !== undefined) {
      firstChild.innerHTML = `- ${label} -`;
      if (selected !== null) {
        firstChild.disabled = true;
      }
    } else {
      const labelOption = document.createElement('option');
      labelOption.dataset.labelOption = '';
      labelOption.innerHTML = `- ${label} -`;
      if (selected !== null) {
        labelOption.disabled = true;
      }

      if (firstChild) {
        this.$.select.insertBefore(labelOption, firstChild);
      } else {
        this.$.select.appendChild(labelOption);
      }
    }
  }

  _selectedChanged(selected) {
    if (!selected || !this.$.select.children.length) {
      return;
    }

    const selectedOption = this.$.select.querySelector(`option[value="${selected}"]`);
    if (selectedOption && !selectedOption.selected) {
      selectedOption.selected = true;
    }

    this._updateInput(selectedOption ? selectedOption.textContent : '');
  }

  _renderOptions(options) {
    const { select } = this.$;
    const currentOptions = select.querySelectorAll('option:not([data-label-option])');

    currentOptions.forEach((option) => {
      select.removeChild(option);
    });

    options.forEach((item) => {
      const option = document.createElement('option');
      option.textContent = item.Label;
      option.value = item.Value;
      select.appendChild(option);
    });

    this._selectedChanged(this.selected);
  }

  _updateInput(text) {
    if (text !== '' && this.keepLabel) {
      text = `${this.label}: ${text}`;
    }
    this.$.input.value = text;
    this.$.input.classList.toggle('input--filled', text !== '');
  }

  _handleSelection() {
    const selectedValue = this.$.select.value || null;
    const selectedOption = this.options.find((option) => option.Value === selectedValue) || null;
    this.selected = selectedValue;
    this.dispatchEvent(new CustomEvent('fit-dropdown-selected', { detail: selectedOption, bubbles: true, composed: true }));
  }

  _hover(event) {
    if (event.type === 'mouseover') {
      this.$.input.classList.add('is-hovered');
    } else {
      this.$.input.classList.remove('is-hovered');
    }
  }
}

customElements.define(FitSimpleDropdown.is, FitSimpleDropdown);
